export const calculateSwimmingVO2max = (distanceMeters, durationSeconds) => {
  const distance = parseFloat(distanceMeters);
  const duration = parseFloat(durationSeconds);

  if (!isFinite(distance) || !isFinite(duration) || distance <= 0 || duration <= 0) {
    console.warn('⚠️ [calculateSwimmingVO2max] Valores inválidos:', { distanceMeters, durationSeconds });
    return { vo2max: null, message: 'No disponible' };
  }

  // Cálculo principal (normalizado para natación)
  const metersPerSecond = distance / duration;
  const vo2max = (metersPerSecond * 1000) / 15;
  const rounded = parseFloat(vo2max.toFixed(2));

  // Interpretación
  let message = 'No disponible';
  if (rounded >= 60) {
    message = '🥇 Nivel élite';
  } else if (rounded >= 50) {
    message = '💪 Muy bueno';
  } else if (rounded >= 40) {
    message = '👍 Aceptable';
  } else {
    message = '⚠️ Bajo';
  }

  return { vo2max: rounded, message };
};
